import { useRef, useState } from 'react';
import * as Slider from '@radix-ui/react-slider';

interface FitScoreSliderProps {
  value: number;
  includeUnscored: boolean;
  onChange: (value: number | null) => void;
  onIncludeUnscoredChange: (value: boolean) => void;
}

export function FitScoreSlider({
  value,
  includeUnscored,
  onChange,
  onIncludeUnscoredChange,
}: FitScoreSliderProps) {
  // Internal state owns display. Only accept prop when it genuinely changes.
  const [displayValue, setDisplayValue] = useState(value);
  const prevProp = useRef(value);
  if (prevProp.current !== value) {
    prevProp.current = value;
    setDisplayValue(value);
  }

  const isActive = displayValue > 0;

  return (
    <div className="space-y-1.5">
      <div className="flex items-center gap-2">
        <label className="text-[10px] font-medium text-icon-subtle whitespace-nowrap">
          Min fit score
        </label>
        <Slider.Root
          className="relative flex items-center select-none touch-none flex-1 h-5"
          min={0}
          max={100}
          step={1}
          value={[displayValue]}
          onValueChange={([v]) => setDisplayValue(v)}
          onValueCommit={([v]) => onChange(v === 0 ? null : v)}
        >
          <Slider.Track className="relative grow rounded-full h-[3px] bg-bg-tertiary">
            <Slider.Range className="absolute rounded-full h-full bg-matcha-500" />
          </Slider.Track>
          <Slider.Thumb className="block w-3.5 h-3.5 rounded-full bg-matcha-600 border-2 border-white shadow-sm hover:bg-matcha-700 focus:outline-none focus:ring-2 focus:ring-matcha-400 focus:ring-offset-1" />
        </Slider.Root>
        <span
          className={`text-[10px] font-semibold tabular-nums min-w-[20px] text-right ${
            isActive ? 'text-content-success' : 'text-icon-subtle'
          }`}
        >
          {displayValue}
        </span>
      </div>
      {isActive && (
        <label className="flex items-center gap-1.5 cursor-pointer select-none">
          <input
            type="checkbox"
            checked={includeUnscored}
            onChange={(e) => onIncludeUnscoredChange(e.target.checked)}
            className="rounded border-border-primary text-content-success focus:ring-matcha-500 h-3 w-3"
          />
          <span className="text-[10px] text-icon-subtle">Include unscored</span>
        </label>
      )}
    </div>
  );
}
